/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/emersya-iframe.js
  var emersyaIframe = /* @__PURE__ */ (() => {
    let retries = 0;
    let firstTriedAt = 0;
    function init() {
      addEventListener("message", (event) => {
        if (!event.data) {
          return;
        }
        if (event.data.action === "onProcessOrder") {
          const orchestraResponse = sendToOrchestra(event.data.basket);
        }
      });
    }
    __name(init, "init");
    function sendToOrchestra(emersyaData) {
      const preAtcLoadingOverlay = document.querySelector(".emersya__pre-atc-loading");
      preAtcLoadingOverlay == null ? void 0 : preAtcLoadingOverlay.classList.add("emersya__pre-atc-loading--visible");
      if (Orchestra && Orchestra.emersya_cart_endpoint) {
        if (orchestraPayload) {
          orchestraPayload.emersya = emersyaData;
          orchestraFetch(Orchestra.emersya_cart_endpoint, orchestraPayload).then((response) => __async(null, null, function* () {
            if (response.success) {
              for (let i = 0; i < 10; i++) {
                const addedToCart = yield addToShopifyCart(response);
                if (addedToCart) {
                  break;
                } else {
                  yield new Promise((res) => setTimeout(res, 5e3));
                }
              }
            } else {
              console.error("Error: Could not reach Orchestra endpoint");
            }
            preAtcLoadingOverlay == null ? void 0 : preAtcLoadingOverlay.classList.remove("emersya__pre-atc-loading--visible");
          }));
        } else {
          preAtcLoadingOverlay == null ? void 0 : preAtcLoadingOverlay.classList.remove("emersya__pre-atc-loading--visible");
          console.error("Error: Could not create Orchestra payload");
          return false;
        }
      } else {
        console.error("Error: Could not find a valid Orchestra endpoint");
        return false;
      }
    }
    __name(sendToOrchestra, "sendToOrchestra");
    function addToShopifyCart(data) {
      return __async(this, null, function* () {
        let ShopifyPayload = {
          items: [
            {
              id: data.id,
              quantity: 1,
              properties: {
                "Package Details": data.packageDetails,
                _configurationCode: data.configurationCode,
                _configurationReplayURL: data.configurationReplayURL,
                _configuratorReplayURL: data.configuratorReplayURL,
                _xero_account_code: data._xero_account_code || null
              }
            }
          ]
        };
        const res = yield fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(ShopifyPayload)
        }).catch((error) => {
          console.error("Error:", error);
        });
        if (res.ok) {
          refreshCart();
          return true;
        }
      });
    }
    __name(addToShopifyCart, "addToShopifyCart");
    function refreshCart() {
      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:refresh", {
          bubbles: true
        })
      );
      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
    }
    __name(refreshCart, "refreshCart");
    return {
      init
    };
  })();
  emersyaIframe.init();
})();
